// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer_2eqi6","text":"Footer_text_AnZ2V","links":"Footer_links_1bzqF"};